// src/sections/ContactSection.jsx
import React from 'react';

const ContactSection = () => (
  <section id="contact" className="contact-section" data-scroll-section>
    <div className="parallax-text white-text" data-scroll data-scroll-speed="2">
      <h2>Contact</h2>
      <p>Let’s create something powerful together.</p>
      <a href="mailto:contact@nrgpix.ch" className="contact-button">Start a Conversation</a>
    </div>
  </section>
);

export default ContactSection;